export default __webpack_public_path__ + "static/media/search.be3e5f35.svg";